module.exports = __webpack_public_path__ + "static/media/001.b0af9d5d.jpg";